export default __webpack_public_path__ + "static/media/ux-collab-cover.8c93a643.png";